import 'core-js/stable';
import {observeVideo, updateViewportHeight} from "./components/video";
import lozad from "lozad";
import LazyLoad from "vanilla-lazyload";
import {initContactsForm} from "./components/contacts-form";
import {ModalWindowFullScreen} from "./components/modal-window";
import {device} from "device.js";
import Bowser from "bowser";
import SmoothScrollbar from "smooth-scrollbar";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger.js";
import Magnetic from "./components/magnetic-effect";
import {isMobile, isTablet} from "./components/helpers";
import {initRplLanding} from "./landings/rpl";
import {initMigcreditLanding} from "./landings/migcredit";
import {initAlfaLanding} from './landings/alfa';
import {initBlogyouLanding} from './landings/blogyou';
import {parallaxEffect} from "./components/parallax-effect";
import {initTransgruzLanding} from "./landings/transgruz";
import {initGradLanding} from "./landings/grad";
import {initBeelineLanding} from "./landings/beeline";
import {initMnedaliLanding} from "./landings/mnedali";
import {initPrimoLanding} from "./landings/primo";
import {initEvpatLanding} from "./landings/evpatoria";
import {initSamaragisLanding} from "./landings/samaragis";
import {initVolgaCliffLanding} from "./landings/volgacliff";
import {initVoznesenskyLanding} from "./landings/voznesensky";
import {initSpnavigatorLanding} from "./landings/spnavigator";
import {initBankiLanding} from "./landings/banki";
import {initFactoringLanding} from "./landings/factoring";
import {initVkladLanding} from './landings/vklad';
import {initReservLanding} from "./landings/reserv";
import {initMigAppLanding} from './landings/migapp';
import {initArchiveLanding} from "./landings/archive";
import {initTemplateLanding} from "./landings/template";
import {initDevSiteLanding} from "./landings/dev_site";
import {initSamaraTravelLanding} from "./landings/samaratravel";
import {initKujbyshev1941Landing} from "./landings/kujbyshev1941";
import {initBitrixLanding} from "./landings/bitrix";

$(function () {

    //подзагрузка картинок на главной
    if ($('div[data-url="/"]').length) {
        initImagePreload('div.inner-bg');
    }

    //подзагрузка картинок на портфолио + цветное bg для видео (пиздец костыль на время)
    // + обработка клика при переходе на проекты с /portfolio,
    // чтобы при переходе назад, проскроллить до места, где ты был
    if ($('div[data-url="/portfolio/"]').length) {
        // initImagePreload('video.video');
        initImagePreload('div.bg-image');

        $(document).find('a.item').each((_, block) => {
            if ($(block).attr('href') === '/portfolio/migkredit-lk/') {
                $(block).find('.translated-block').addClass('mig');

            } else if ($(block).attr('href') === '/portfolio/alfa-bank/') {
                $(block).find('.translated-block').addClass('alfa');

            } else if ($(block).attr('href') === '/portfolio/premierliga/') {
                $(block).find('.translated-block').addClass('rpl');

            } else if ($(block).attr('href') === '/portfolio/mnedali/') {
                $(block).find('.translated-block').addClass('mnedali');

            } else if ($(block).attr('href') === '/portfolio/beeline/') {
                $(block).find('.translated-block').addClass('beeline');

            }
        })
    }

    //под загрузка картинок на текучке
    if ($('div[data-url="/updates/"]').length) {
        initImagePreload('div.inner-bg');
    }

    function initImagePreload(block) {
        $(document).find(block).each((_, preloadBlock) => {
            const imageHref = $(preloadBlock).data('background-image') || $(preloadBlock).data('bg') || '';
            const isVideo = block.includes('video');
            let link = document.createElement('link');

            link.href = isVideo ? $(preloadBlock).find('source').data('src') : imageHref;
            link.rel = 'preload';
            link.as = isVideo ? 'video' : 'image';
            link.type = isVideo ? 'mp4/video' : '';

            document.head.appendChild(link);
            $(preloadBlock).css('opacity', '1');
        })
    }

    // модальные окна фулскрин
    const modalWindow = new ModalWindowFullScreen();

    //костыль для видео, чтобы после загрузки видоса не было пустоты заместо постера
    $("video").on('play', function () {
        if (this.getAttribute('controls') !== 'true') {
            this.setAttribute('controls', 'true');
        }
        this.removeAttribute('controls');
    });


    try {
        const browser = Bowser.getParser(window.navigator.userAgent);
        const name = browser.getBrowser().name || '';
        device.addClasses(document.documentElement);
        $('html').addClass(name.toLowerCase());
        if($('html').hasClass('desktop') && !$('html').hasClass('windows') && !$('html').hasClass('mobile') && !$('html').hasClass('tablet')){
            $('html').addClass('mac');
        }

    } catch (e) {
        console.warn(e)
    }

    gsap.config({
        autoSleep: 60,
        force3D: true,
        nullTargetWarn: false,
        trialWarn: false,
        units: {left: "%", top: "%", rotation: "rad"}
    });
    gsap.registerPlugin(ScrollTrigger);

    if (!isMobile() && !isTablet()) {

        let bodyScrollBar = SmoothScrollbar.init(
            $('.scroller')[0],
            {
                continuousScrolling: false,
                renderByPixels: true,
                damping: 0.12,
            }
        );

        ScrollTrigger.scrollerProxy(".scroller", {
            scrollTop(value) {
                if (arguments.length) {
                    bodyScrollBar.scrollTop = value;
                }
                return bodyScrollBar.scrollTop;
            },
        });

        bodyScrollBar.addListener(ScrollTrigger.update);

        //обработка клика при переходе на проекты с /portfolio,
        // чтобы при переходе назад, проскроллить до места, где ты был
        const isPortfolio = $('div[data-url="/portfolio/"]').length;
        const isArchive = $('div[data-url="/portfolio/archive/"]').length;

        if (isPortfolio) {
            $('a.item').on('click', () => {
                const scroll = bodyScrollBar.scrollTop;
                sessionStorage.setItem('lastScroll', `${scroll}`);
            });
        }

        if (isArchive) {
            $('.work[data-href]').on('click', () => {
                const scroll = bodyScrollBar.scrollTop;
                sessionStorage.setItem('lastScrollArchive', `${scroll}`);
            });
        }


        let isPortfolioWorksLastPosition = sessionStorage?.getItem('lastPosition')?.includes('portfolio');
        let isArchiveWorksLastPosition = sessionStorage?.getItem('lastPosition')?.includes('/portfolio/archive/');

        if (sessionStorage.getItem('lastScroll') && isPortfolio && isPortfolioWorksLastPosition) {
            bodyScrollBar.scrollTop = +sessionStorage.getItem('lastScroll');
            sessionStorage.setItem('lastScroll', '0');
            sessionStorage.setItem('lastPosition', 'no');
        }

        if (sessionStorage.getItem('lastScrollArchive') && isArchive && isArchiveWorksLastPosition) {
            bodyScrollBar.scrollTop = +sessionStorage.getItem('lastScrollArchive');
            sessionStorage.setItem('lastScrollArchive', '0');
            sessionStorage.setItem('lastPositionArchive', 'no');
        }

        sessionStorage.setItem('lastPosition', window.location.pathname);
        sessionStorage.setItem('lastPositionArchive', window.location.pathname);
    }

    updateViewportHeight();
    initContactsForm();

    observeVideo();

    resizeAllVideoBlocks();

    $(window).on('resize', () => {
        resizeAllVideoBlocks();
    });

    parallaxEffect();
    initRplLanding();
    initMigcreditLanding();
    initAlfaLanding();
    initBlogyouLanding();
    initTransgruzLanding();
    initGradLanding();
    initBeelineLanding()
    initSamaragisLanding()
    initMnedaliLanding();
    initPrimoLanding();
    initEvpatLanding();
    initVolgaCliffLanding();
    initVoznesenskyLanding();
    initSpnavigatorLanding();
    initBankiLanding();
    initFactoringLanding()
    initVkladLanding();
    initReservLanding();
    initMigAppLanding();
    initArchiveLanding();
    initTemplateLanding();
    initDevSiteLanding();
    initSamaraTravelLanding();
    initKujbyshev1941Landing();
    initBitrixLanding();

    $(window).on('orientationchange', (event) => {
        console.log("The orientation of the screen is: " + screen.orientation.type);
        setTimeout(() => {
            updateViewportHeight();
        }, 250)
    })


    const navigationMenu = $('.navigation-menu');
    let playState = true;
    const animationTime = 0.05;

    const navigationTimeline = gsap.timeline({
        paused: true
    })

    if (!isMobile()) {
        if (!$('.theme-black-with-round').length) return;
        $('.theme-black-with-round').on('mouseenter', (e) => {
            const $this = $(e.currentTarget);
            initAnimateButtonHandler($this, e, 'mouseenter')

        }).on('mouseleave', (e) => {
            const $this = $(e.currentTarget);

            initAnimateButtonHandler($this, e, 'mouseleave')
        })
    }

    function initAnimateButtonHandler($this, e, type = '',) {
        const pointerPosition = {
            x: e.clientX,
            y: e.clientY
        }

        const buttonPosition = {
            left: $this.offset().left,
            top: $this.offset().top
        }
        const diameter = Math.max($this.width(), $this.height());
        const radius = diameter / 2;

        const left = pointerPosition.x - (buttonPosition.left + radius);
        const top = pointerPosition.y - (buttonPosition.top + radius);
        const x = pointerPosition.x - (buttonPosition.left + radius);
        const y = pointerPosition.y - (buttonPosition.top + radius);

        let scale = 4;
        if (type !== 'mouseenter') {
            scale = 0;
        }

        gsap.to($this.find('.button-round-item'), {
            left,
            top,
            x,
            y,
            scale,
            duration: .25,
            force3D: true,
        })
    }

    navigationTimeline.from(
        navigationMenu,
        {
            x: '-100%',
            ease: 'power1',
            willChange: 'transform',
            duration: 0.2,
            force3D: true,
            onComplete: () => {
                console.log('complete')
            },
            onReverseComplete: () => {
                console.log('reversecomplete')
                gsap.to('.nav .item', {
                    stagger: {
                        each: 0.05,
                        axis: "x",
                    },
                    ease: 'power1',
                    opacity: 0,
                    x: '100%',
                    force3D: true,
                })

                gsap.to('.bg-blur-pxl', {
                    opacity: 0,
                    duration: 0.2,
                    willChange: 'opacity',
                    force3D: true,
                })
            }
        },
    ).to(navigationMenu,
        {
            x: '0%',
            ease: 'power1',
            willChange: 'auto',
            duration: 0.2,
            smoothChildTiming: true,
            force3D: true,
            onReverseComplete: () => {
                console.log('reverseCompleteTo')
            },
            onComplete: () => {
                console.log('CompleteTo')
                gsap.to('.nav .item', {
                    stagger: {
                        each: 0.05,
                        axis: "x",
                    },
                    ease: 'power1',
                    duration: 0.2,
                    opacity: 1,
                    x: '0%',
                    force3D: true,
                })

                gsap.to('.bg-blur-pxl', {
                    opacity: 1,
                    duration: 0.2,
                    willChange: 'opacity',
                    force3D: true,
                })
            }
        })

    $('.burger-menu, .bg-blur-pxl').on('click', (e) => {
        if ($('body').hasClass('closed-menu')) {
            $('body').removeClass('closed-menu').addClass('open-menu')
        } else {
            $('body').removeClass('open-menu').addClass('closed-menu');
        }
        if (playState) {
            playState = false
            navigationTimeline.play()
        } else {
            navigationTimeline.reverse();
            playState = true;
        }
    })

    if ($('body').hasClass('load')) {
        setTimeout(() => {
            $('body').removeClass('load');
        }, 600)
    }


    const observer = lozad();
    observer.observe();

    //test
    const lazyLoadInstance = new LazyLoad();

    $('[data-magnetic]').each(function () {
        new Magnetic(this);
    });

    function resizeAllVideoBlocks() {
        if ($('.imac-new-block').length) {
            resizeTargetVideoBlock('.imac-new-block');
        }

        if ($('.video-block').length) {
            resizeTargetVideoBlock('.video-block');
        }

        function resizeTargetVideoBlock(target) {
            $.each($(`${target}`), function () {
                const width = $(this).find('video').attr('width')
                const height = $(this).find('video').attr('height')
                const ratio = height / width * 100
                let targetForImac = target == '.imac-new-block' ? '.imac-new-block .imac-content' : target

                $(targetForImac).css({
                    'padding-top': ratio + '%'
                })
            })
        }
    }

    //console.log('istablet=', isTablet(), 'isMobile=',isMobile(), isMobile() || isTablet(), isMobile() && isTablet())

    // $(window).on("load", function() {
    //     gsap.registerPlugin(ScrollTrigger);
    //
    //     gsap.utils.toArray(".panel").forEach((panel, i) => {
    //         ScrollTrigger.create({
    //             trigger: panel,
    //             //scroller: '.scroller',
    //             start: "top top",
    //             pin: true,
    //             pinSpacing: false
    //         });
    //     });
    //
    //
    //     ScrollTrigger.create({
    //         snap: 1 / 4 // snap whole page to the closest section!
    //     });
    // })

    setTimeout(() => {
        SmoothScrollbar.get($('.scroller')[0]).update()
    }, 3000)

});
